import {
  Component,
  forwardRef,
  Input
} from '@angular/core';

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

import { MatDatepicker } from '@angular/material/datepicker';
import { MAT_DATE_FORMATS } from '@angular/material/core';

export const MY_MONTH_FORMATS = {
  parse: {
    dateInput: { month: 'short', year: 'numeric' },
  },
  display: {
    dateInput: { month: 'short', year: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Component({
  selector: 'app-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MonthPickerComponent),
      multi: true
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_MONTH_FORMATS }
  ]
})
export class MonthPickerComponent implements ControlValueAccessor {

  @Input() label = 'Month & Year';
  @Input() placeholder = 'Select Month';
  @Input() maxDate: Date = new Date();

  value: Date = new Date();
  displayValue = '';

  private readonly months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  constructor() {
    this.updateDisplayValue();
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: Date): void {
    if (value) {
      this.value = new Date(value);
    } else {
      this.value = new Date();
    }

    this.updateDisplayValue();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {}

  chosenYearHandler(normalizedYear: Date): void {
    this.value.setFullYear(normalizedYear.getFullYear());
  }

  chosenMonthHandler(
    normalizedMonth: Date,
    datepicker: MatDatepicker<Date>
  ): void {

    this.value.setMonth(normalizedMonth.getMonth());

    // Create a new Date object so Angular detects the change
    this.value = new Date(this.value);

    this.updateDisplayValue();

    this.onChange(this.value);
    this.onTouched();

    datepicker.close();
  }

  private updateDisplayValue(): void {
    this.displayValue =
      `${this.months[this.value.getMonth()]} ${this.value.getFullYear()}`;
  }
}